import { Settings } from './subpages/Settings';
import { Builder } from './subpages/Builder';
import { TimelineTable } from './subpages/TimelineTable';
import { ExecutionsTable } from './subpages/ExecutionsTable';
import { TFunction } from 'react-i18next';

const accountUrlBase = '/smartconnectors/:id/settings';

export const subroutes = {
  settings: {
    label: (t: TFunction) => t('Settings'),
    component: Settings,
    exact: true,
    icon: 'cogs-light',
    path: accountUrlBase,
  },
  build: {
    label: (t: TFunction) => t('Build'),
    component: Builder,
    exact: true,
    icon: 'tools-light',
    path: `${accountUrlBase}/build`,
  },
  executions: {
    label: (t: TFunction) => t('Executions'),
    component: ExecutionsTable,
    exact: true,
    icon: 'play-light',
    path: `${accountUrlBase}/executions`,
  },
  timeline: {
    label: (t: TFunction) => t('Timeline'),
    component: TimelineTable,
    exact: true,
    icon: 'timeline-arrow-light',
    path: `${accountUrlBase}/timeline`,
  },
};
